import { Body, Button, colors, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import { TokenListItem } from '../TokenListItem'
import eth from '../../../../../assets/img/ethereum.svg'
import polygon from '../../../../../assets/img/polygon.svg'
import binance from '../../../../../assets/img/binance.svg'
import avax from '../../../../../assets/img/avalanche.svg'
import { noSelect } from '../../../../../utils/noSelect'
import { useWeb3Connection } from '../../../../../web3/Web3Provider'
import { cssVar } from '../../../../../theme/utils'
import { getChainInfo, Network } from '@spritz-finance/sdk'
import { useApolloClient } from '@apollo/client'
import { Row } from '../../../../../components/Layout/Row'

export const nativeTokenImg = {
    [Network.Binance]: binance,
    [Network.Polygon]: polygon,
    [Network.Avalanche]: avax,
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const TokenWrapper = styled.div`
    ${noSelect};
    border-radius: 6px;
    border: 1px solid #898989;
    padding: 0 16px;
    padding-left: 16px;
`

export const TokenSelectEmptyState = () => {
    const client = useApolloClient()
    const { connectedNetwork } = useWeb3Connection()

    if (!connectedNetwork) return null

    const secondaryLine = connectedNetwork
        ? 'Please add tokens to your wallet in order to make a payment.'
        : 'Please switch networks in order to make a payment.'
    const chainInfo = getChainInfo(connectedNetwork!)

    const refetch = () => client.refetchQueries({ include: ['GetBalances'] })
    return (
        <Container>
            <TokenWrapper>
                <TokenListItem
                    token={{
                        symbol: chainInfo.nativeCurrency!.symbol,
                        tokenImageUrl: nativeTokenImg[connectedNetwork] ?? eth,
                        balance: 0,
                        balanceUSD: 0,
                    }}
                />
            </TokenWrapper>
            <Spacer height={8} />
            <Body.Med size={12} color={cssVar('--text-error', colors.orchid)}>
                {`We couldn't find any tokens in your connected wallet on ${chainInfo.name}.`}
            </Body.Med>
            <Body.Med size={12} color={cssVar('--text-error', colors.orchid)}>
                {secondaryLine}
            </Body.Med>
            <Spacer height={16} />
            <Row align="center">
                <Button.CTA responsive onClick={refetch}>
                    Refresh balance
                </Button.CTA>
            </Row>
        </Container>
    )
}
